import React, { useState } from 'react'
import Header_Orion from './Header_Orion'
import useWindowDimensions from "../../../hook/useWindowDimensions";

const sidebarClass = {
  intial: {
    main: "app-container app-theme-white_bus body-tabs-shadow fixed-sidebar fixed-header",
    button: "hamburger close-sidebar-btn hamburger--elastic"
  }
}

const sidebarClassMobile = {
  intial: {
    main: "app-container app-theme-white_bus body-tabs-shadow fixed-sidebar fixed-header closed-sidebar-mobile closed-sidebar",
    button: "hamburger hamburger--elastic mobile-toggle-nav"
  }
}

export default function LayoutMain_Orion(props) {
  const [mainClass, setMainClass] = useState(sidebarClass);
  const [mainClassMobile, setMainClassMobile] = useState(sidebarClassMobile);
  const { width } = useWindowDimensions();

  let class_name;
  if (width >= 991) {
    class_name = mainClass.intial.main;
  } else {
    class_name = mainClassMobile.intial.main;
  }
  return (
    <>
      <div className={class_name}>
        <Header_Orion />
        <div className="container-fluid pt-2 pb-2" style={{ background: '#F2F3FC' }}>
          <div className="app-main_bus">
            <div className="app-main__inner">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
